import {
  DeliveredWeeklyVenn,
  WeeklyVenn,
} from "@dimensional-engineering/dimensional-models";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type WeeklyVennSlice = {
  latestVenn: WeeklyVenn | null;
  deliveredForLatest: DeliveredWeeklyVenn | null;
  weeklyVennLoaded: boolean;
};

const initialState: WeeklyVennSlice = {
  latestVenn: null,
  deliveredForLatest: null,
  weeklyVennLoaded: false,
};

export const weeklyVenn = createSlice({
  name: "weeklyVenn",
  initialState: initialState,
  reducers: {
    setLatestWeeklyVenn: (state, action: PayloadAction<WeeklyVenn | null>) => {
      return { ...state, latestVenn: action.payload };
    },
    setDeliveredWeeklyVenn: (
      state,
      action: PayloadAction<DeliveredWeeklyVenn | null>
    ) => {
      return { ...state, deliveredForLatest: action.payload };
    },
    setWeeklyVennLoaded: (state, action: PayloadAction<boolean>) => {
      return { ...state, weeklyVennLoaded: action.payload };
    },
  },
});

export const {
  setLatestWeeklyVenn,
  setDeliveredWeeklyVenn,
  setWeeklyVennLoaded,
} = weeklyVenn.actions;

export default weeklyVenn.reducer;
